export const langKeyFormatter = (key: string) => {
  return key.replace(/\s+/g, '_').toLowerCase()
}

export const langKeyParser = (key: string) => {
  return key.replace(/_/g, ' ')
}

export const languageShortNameFormatter = (key: string) => {
  const languageMap: {[key: string]: string} = {
    english: 'en',
    arabic: 'ar',
    danish: 'da',
    dutch: 'nl',
    french: 'fr',
    german: 'de',
    greek: 'el',
    hindi: 'hi',
    indonesian: 'id',
    italian: 'it',
    malay: 'ms',
    norwegian: 'no',
    portuguese: 'pt',
    russian: 'ru',
    spanish: 'es',
    swedish: 'sv',
    ukrainian: 'uk',
  }

  const formattedKey = key.replace(/\s+/g, '_').toLowerCase()
  return languageMap[formattedKey] || formattedKey
}

export const languageShortNameParser = (shortCode: string) => {
  const languageMap: {[key: string]: string} = {
    en: 'English',
    ar: 'Arabic',
    da: 'Danish',
    nl: 'Dutch',
    fr: 'French',
    de: 'German',
    el: 'Greek',
    hi: 'Hindi',
    id: 'Indonesian',
    it: 'Italian',
    ms: 'Malay',
    no: 'Norwegian',
    pt: 'Portuguese',
    ru: 'Russian',
    es: 'Spanish',
    sv: 'Swedish',
    uk: 'Ukrainian',
  }

  return languageMap[shortCode.toLowerCase()] || shortCode
}
